module.exports = __webpack_public_path__ + "img/nike-black.77e29371.jpg";